function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "logout-line",
  transform: "translate(-2.221 -1.777)"
}, React.createElement("path", {
  id: "Path_11926",
  "data-name": "Path 11926",
  d: "M5.889,4.889H13V9.245h.889V4.889A.889.889,0,0,0,13,4H5.889A.889.889,0,0,0,5,4.889V15.557a.889.889,0,0,0,.889.889H13a.889.889,0,0,0,.889-.889h-8Z",
  transform: "translate(-2.779 -2.223)",
  fill: "rgba(0,0,0,0.65)"
}), React.createElement("path", {
  id: "Path_11927",
  "data-name": "Path 11927",
  d: "M20.641,17.146a.444.444,0,0,0-.626.626l1.5,1.471H15.074a.444.444,0,0,0,0,.889h6.442l-1.5,1.537a.444.444,0,1,0,.626.626l2.595-2.577Z",
  transform: "translate(-8.124 -9.465)",
  fill: "rgba(0,0,0,0.65)"
}));

var SvgLogoutLine = function SvgLogoutLine(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12.89,
    height: 12.445,
    viewBox: "0 0 12.89 12.445",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoutLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout-line.e132e198.svg";
export { ForwardRef as ReactComponent };